export const ASSIGNMENT_CONCURRENCY_LIMIT = 6

export type AssignmentBatchResult =
  | {
      nodeId: string
      status: 'fulfilled'
    }
  | {
      nodeId: string
      status: 'rejected'
      reason: unknown
    }

export async function runAssignmentBatch(
  nodeIds: readonly string[],
  operation: (nodeId: string) => Promise<void>,
): Promise<AssignmentBatchResult[]> {
  if (nodeIds.length === 0) return []

  const results = new Array<AssignmentBatchResult>(nodeIds.length)
  let nextIndex = 0

  async function worker(): Promise<void> {
    while (nextIndex < nodeIds.length) {
      const index = nextIndex
      nextIndex += 1
      const nodeId = nodeIds[index]

      try {
        await operation(nodeId)
        results[index] = { nodeId, status: 'fulfilled' }
      } catch (reason: unknown) {
        results[index] = { nodeId, status: 'rejected', reason }
      }
    }
  }

  const workerCount = Math.min(ASSIGNMENT_CONCURRENCY_LIMIT, nodeIds.length)
  await Promise.all(Array.from({ length: workerCount }, () => worker()))
  return results
}
